var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V4H4C2.89543 4 2 4.89543 2 6V14C2 15.1046 2.89543 16 4 16H7.75545L5.31064 21.7046C5.14747 22.0853 5.32384 22.5262 5.70456 22.6894C6.08528 22.8525 6.52619 22.6762 6.68936 22.2954L9.3874 16H11.25V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V16H14.6126L17.3106 22.2954C17.4738 22.6762 17.9147 22.8525 18.2954 22.6894C18.6762 22.5262 18.8525 22.0853 18.6894 21.7046L16.2445 16H20C21.1046 16 22 15.1046 22 14V6C22 4.89543 21.1046 4 20 4H12.75V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboard);
export default __webpack_public_path__ + "static/media/blackboard.23be10af9243b8b36758a6c0180fc4f4.svg";
export { ForwardRef as ReactComponent };